import { render, staticRenderFns } from "./ChatArea2.vue?vue&type=template&id=bd4b0a84&scoped=true"
import script from "./ChatArea2.vue?vue&type=script&lang=js"
export * from "./ChatArea2.vue?vue&type=script&lang=js"
import style0 from "./ChatArea2.vue?vue&type=style&index=0&id=bd4b0a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4b0a84",
  null
  
)

export default component.exports